export default __webpack_public_path__ + "static/404-cd7deb1180bd60b6f08cda5324cadd1f.svg";